import api from './authService';

/**
 * Fetch public FAQs for Help Center (no auth required).
 * @param {Object} params - Optional { category: string }
 * @returns {Promise}
 */
export const getPublicFAQs = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return api.get(`/faqs${queryString ? `?${queryString}` : ''}`);
};
